import React from 'react';
import {patientContacts} from '../services/patientOperations';
import './PatientOperations.css';
export function PatientContactActions({patient}) {
 const contacts=patientContacts(patient);
 return <div className="patient-contact-actions" aria-label={`Contatta ${patient.firstName} ${patient.lastName}`}>
  {contacts.call&&<a href={contacts.call}>Chiama</a>}
  {contacts.whatsapp&&<a href={contacts.whatsapp} target="_blank" rel="noreferrer">WhatsApp</a>}
  {contacts.email&&<a href={contacts.email}>Email</a>}
  {!contacts.call&&!contacts.email&&<span>Nessun recapito utilizzabile</span>}
  {contacts.call&&!contacts.whatsapp&&<small>Per WhatsApp aggiungi il prefisso internazionale al telefono.</small>}
 </div>;
}
